import { Phone } from 'lucide-react';

/**
 * Numéro lisible : « 06 25 46 89 12 » (français, par paires) ou « +33 6 25 46 89 12 ».
 * Tout autre format est laissé tel quel. (Même règle que le planning du bureau.)
 */
export function formatPhone(raw?: string | null) {
  const value = (raw ?? '').trim();
  const digits = value.replace(/[\s.\-()]/g, '');
  const pairs = (d: string) => d.replace(/(\d{2})(?=\d)/g, '$1 ');
  if (/^0\d{9}$/.test(digits)) return pairs(digits);
  if (/^(\+33|0033)\d{9}$/.test(digits)) return `+33 ${digits.slice(-9, -8)} ${pairs(digits.slice(-8))}`;
  return value;
}

/** Lien d'appel vers l'élève (le téléphone compose le numéro). */
export default function PhoneLink({
  phone,
  name,
  compact = false,
}: {
  phone?: string | null;
  name: string;
  compact?: boolean;
}) {
  if (!phone) return null;
  const href = `tel:${phone.replace(/[^\d+]/g, '')}`;
  return compact ? (
    <a
      href={href}
      aria-label={`Appeler ${name} au ${formatPhone(phone)}`}
      title={`Appeler ${name}`}
      onClick={(e) => e.stopPropagation()}
      className="w-10 h-10 flex-shrink-0 rounded-full border border-indigo-200 bg-white text-indigo-600 flex items-center justify-center hover:bg-indigo-50"
    >
      <Phone size={16} aria-hidden />
    </a>
  ) : (
    <a
      href={href}
      aria-label={`Appeler ${name} au ${formatPhone(phone)}`}
      onClick={(e) => e.stopPropagation()}
      className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-semibold text-indigo-700 hover:underline"
    >
      <Phone size={13} aria-hidden />
      {formatPhone(phone)}
    </a>
  );
}
